import { all } from "redux-saga/effects";

//Watchers
import authSagas from "./auth";
import { accountWatcher } from "./account";
import { changeSetpoint } from "./changeSetpoint";
import { clientWatcher } from "./client";
import { dbSync } from "./dbSync";
import { dbWatcher } from "./db";
import { fetchData } from "./fetchData";
import { formWatcher, resetFormErrors } from "./forms";
import { initWatcher } from "./init";
import { logsWatcher } from "./logs";
import { menuWatcher } from "./menu";
import { routeWatcher } from "./router";
import { syncWatcher } from "./sync";

export default function* rootSaga() {
  yield all([
    logsWatcher(),
    initWatcher(),
    authSagas(),
    changeSetpoint(),
    fetchData(),
    routeWatcher(),
    formWatcher(),
    resetFormErrors(),
    accountWatcher(),
    menuWatcher(),
    clientWatcher(),
    dbWatcher(),
    syncWatcher(),
    dbSync()
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/rootSaga.js